import React, { useState, useEffect } from "react";
import DropDownInput from "../../DropDownInput/DropDownInput";
import InventoryItem from "./InventoryItem/InventoryItem";
import { useParams } from "react-router-dom";

export default function RecordInventory(props) {
  const { id } = useParams();
  const { record, setSelectedLibrary, selectedLibrary, title } = props;

  const handleLibraryChange = (event) => {
    setSelectedLibrary(event.target.value);
  };

  const locations=[{id:1,library:'Archivo Central'}]

  useEffect(() => {
    console.log(record)
  }, []);

  return (
    <>
      {/* <h2>Hola</h2> */}
      {(
        <div className="row bg-white p-2 shadow-sm rounded mb-3" id="inventory">
          <div className="col-12">
            <h5 className="my-2">Ubicación de unidad documental</h5>
            <div className="row">
              <div className="col-12 col-lg-3 mb-4">
                <label htmlFor="biblio">Ubicacion:</label>
                <div className="form-group">
                  { (
                    <DropDownInput
                      onChange={handleLibraryChange}
                      name="biblio"
                      options={locations
                        ?.map((item, index) => ({
                          value: item.library,
                          displayText: item.library,
                          selected: index === 0,
                        }))}
                    />
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-9">
                <InventoryItem item={title} record={record} />
              </div>
            </div>
          </div>
        </div>
      )}

      
    </>
    
  );
}
